import {DatabaseCode, toDatabaseCode} from "./database-code";

export type NotificationThreadInboundActionType = DatabaseCode;

const threadOnly: NotificationThreadInboundActionType = {
  code: "THREAD_ONLY",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.inboundactiontype.threadonly",
    defaultMessage: "Thread Only",
  },
};

const createTask: NotificationThreadInboundActionType = {
  code: "CREATE_TASK",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.inboundactiontype.createtask",
    defaultMessage: "Create Task",
  },
};

const addContextComment: NotificationThreadInboundActionType = {
  code: "ADD_CONTEXT_COMMENT",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.inboundactiontype.addcontextcomment",
    defaultMessage: "Add Context Comment",
  },
};

const escalate: NotificationThreadInboundActionType = {
  code: "ESCALATE",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.inboundactiontype.escalate",
    defaultMessage: "Escalate",
  },
};

const triggerHandler: NotificationThreadInboundActionType = {
  code: "TRIGGER_HANDLER",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.inboundactiontype.triggerhandler",
    defaultMessage: "Trigger Handler",
  },
};

export const notificationThreadInboundActionType = {
  threadOnly,
  createTask,
  addContextComment,
  escalate,
  triggerHandler,
};

export const notificationThreadInboundActionTypes = Object.values(notificationThreadInboundActionType);

export const toNotificationThreadInboundActionType = (code: string): NotificationThreadInboundActionType =>
  toDatabaseCode(code, notificationThreadInboundActionTypes);

export const toNotificationThreadInboundActionTypeSafely = (
  code: string | undefined,
): NotificationThreadInboundActionType | undefined =>
  code ? toDatabaseCode(code, notificationThreadInboundActionTypes) : undefined;
